import React from 'react'
import MappingSelect from '../../Shared/Components/MappingSelect'
import Shared from '../../Shared/mappingUi.module.css'
import Style from '../salesPersonMapping.module.css'

const MappingRow = ({ row, erpSalesPersons, ecommerceSalesPersons, isDisabled, onChange, onRemove }) => (
    <li className={[Shared.row, row.isNew ? Shared.rowNew : ''].join(' ').trim()}>
        <div className={`${Shared.grid} ${Style.grid}`}>
            <MappingSelect
                inputId={`erpSalesPerson-${row.rowId}`}
                options={erpSalesPersons}
                value={row.erpSalesPersonCode}
                placeholder="Select ERP Sales Person"
                customLabel="Custom ERP Sales Person"
                customPlaceholder="Enter ERP sales person code"
                hasError={row.erpSalesPersonCode === ''}
                isDisabled={isDisabled}
                onChange={(value, option) => onChange(row.rowId, {
                    erpSalesPersonCode: value,
                    erpSalesPersonId: option ? option.id : ''
                })}
            />
            <span className={Shared.arrow} aria-hidden="true">&rarr;</span>
            <MappingSelect
                inputId={`ecommerceSalesPerson-${row.rowId}`}
                options={ecommerceSalesPersons}
                value={row.ecommerceSalesPersonCode}
                placeholder="Select eCommerce Sales Person"
                customLabel="Custom eCommerce Sales Person"
                customPlaceholder="Enter eCommerce sales person code"
                hasError={row.ecommerceSalesPersonCode === ''}
                isDisabled={isDisabled}
                onChange={(value, option) => onChange(row.rowId, {
                    ecommerceSalesPersonCode: value,
                    ecommerceSalesPersonId: option ? option.id : ''
                })}
            />
            <button
                type="button"
                className={Shared.deleteButton}
                title="Remove mapping"
                aria-label={`Remove mapping for ${row.erpSalesPersonCode || 'this row'}`}
                disabled={isDisabled}
                onClick={() => onRemove(row.rowId)}
            >
                <i className="uil-trash-alt" aria-hidden="true" />
            </button>
        </div>
        {row.isNew ? <span className={Shared.newBadge}>Not saved yet</span> : null}
    </li>
)

export default React.memo(MappingRow)
